module.exports = __webpack_public_path__ + "img/estadisticas.6d8edf1d.svg";